import React, { Component } from 'react';
import ReactDOM from 'react-dom'



export default class LFMap extends Component {

  state = {
    zoom: 10,
    lat: 36.9741708,
    lng: -122.0277615
  }

  
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.google !== this.props.google || 
      ( prevProps.lfItems !== this.props.lfItems ) ) {

        this.loadMap();
    }

  }
  



  buildInfoWindow = ( marker, lfItem, url, google ) => {
    let infoHtml = "<html>";
   
    /* image container */
    
    if( lfItem.status === 1 )
      infoHtml += '<p " style="margin-top: 1em"> <font size="4" face="sans-serif">' + 'Lost pet' + ' </font> </p> ';
    else
      infoHtml += '<p " style="margin-top: 1em"><font size="4" face="sans-serif">' + 'Found pet' + '  </font> </p> ';


    if( url != null ){
       
      infoHtml += '<img src="' + url + '" alt="photo" style="border: 1px solid #000; max-width:150px; max-height:150px">';
    }
  
    infoHtml += '</br>';

      infoHtml += '<p align="center" style="margin-top: 1em"> <font size="4" face="sans-serif">' + lfItem.name + ' </font> </p> ';
    
    if( lfItem.reward !== "" ){
      infoHtml += '<p align="center" style="margin-top: 1em"> <font size="4" color="4AA02C" face="sans-serif"> Reward : ' + lfItem.reward + ' </font> </p> ';
            
    }
    if( lfItem.extraInformation !== "" ){
      infoHtml += lfItem.extraInformation;
    }
    

    infoHtml += `</br></br>Contact information:`;
    infoHtml += '</br>Name : ' + lfItem.contactName;
    infoHtml += '</br>Email : ' + lfItem.contactEmailAddress;
    infoHtml += '</br>Phone number : ' + lfItem.contactPhoneNumber;
    
    // console.log( "infoHtml = " + infoHtml );

    let infowindow = new google.maps.InfoWindow({
      content: infoHtml,
    });

    marker.addListener('click', function() {
      if( lfItem.status === 0 ){
        
        // Status = 0 means the lfItem is in the 'init' state.
        // callback with the lfItem.

        this.props.onRequestShowAddDialog( lfItem );
      }
      else{
        infowindow.open(this.map, marker);
      }
    }.bind(this));

    
  }

  loadMap = () => {

    if (this.props && this.props.google) {

      const {google} = this.props;
      const maps = google.maps;

      const mapRef = this.refs.map;
      const node = ReactDOM.findDOMNode(mapRef);

      const mapConfig = Object.assign({}, {
        center: new maps.LatLng(this.state.lat, this.state.lng),
        zoom: this.state.zoom,
        gestureHandling: "cooperative",
        mapTypeId: 'terrain',


        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER
        },
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP
        },
        scaleControl: true,
        
      })
      this.map = new maps.Map(node, mapConfig);

     
      this.map.addListener('click', (event) => {
        // notify the parent container.
        this.props.handleMapClick( event.latLng);
        
        
      })
      
      if( this.props.lfItems != null ){
    
        this.props.lfItems.map( (lfItem) => {
    
          let markerFilename = "marker_lost.png";
          if( lfItem.status === 1 ){
            if( lfItem.reward === "" ){
              markerFilename = "marker_lost.png";
            }
            else{
              markerFilename = "marker_reward.png";
            }
          }
          else if( lfItem.status === 2 ){
            markerFilename = "marker_found.png";
          }
          else{
            markerFilename = "marker_init.png";
          }

          const marker = new google.maps.Marker({
            position: {lat: lfItem.lat, lng: lfItem.lng},
            map: this.map,
            title: lfItem.name,
            icon: {
              url: markerFilename
            }

           
          });

          
          if( lfItem.filename !== "" ){
            this.props.fbStorageRef.child('images/' + lfItem.filename).getDownloadURL().then(function(url) {
              this.buildInfoWindow( marker, lfItem, url, google );
            }.bind(this)).catch(function(error) {
              // Handle any errors
            });
          }
          else{
            this.buildInfoWindow( marker, lfItem, null, google );
          }
          

 

        })
      }

    }
  }

  render() {
    const style = {
      width: '100%',
      height: '600px',
      borderRadius: '25px',
    }

    return (

      <div ref="map" style={style}>
        loading map...
      </div>

    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/LFMap.js